import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function App() {
  const adminEnabled = process.env.REACT_APP_ENABLE_ADMIN === 'true';

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {adminEnabled && (
          <>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
